import React, {Component} from 'react';
import classNames from "classnames";
import * as Parse from "../../utils/parsers";
import * as Request from '../../service/data-info-chart/requestsUtil';
import * as Formatter from '../../utils/formatters'
import {COLORS, CONTACT_CENTER, REO} from "../../utils/constants";
import SimpleMonthPicker from "../ui-components/SimpleMonthPicker";

var Loader = require('react-loader');


export const BoxSingle = (props) => {
  // Used a style const for changing icon box
  // color using props.
  const style = {
    backgroundColor: props.iconbg
  };

  return (
    <div className="iconbox-single" style={{height: '90%'}}>
      <div className="box-title">
        <div>
          <h5 style={{color: COLORS.SUMMARY_GREEN}}>{props.title}</h5>
          <p style={{color: COLORS.SUMMARY_GRAY}}>{props.subtitle}</p>
        </div>
      </div>
      <div className="chart">
        {props.children}
      </div>
    </div>
  );
};


export default class ReoContactCenter extends Component {

  constructor(props) {
    super(props);

    var moment = require('moment');
    var week = moment().isoWeek();

    var today = Parse.toCustomDateLastDay(new Date());
    this.state = {data: [], date: today, firstWeek: (week - 1), loaded: false, key: 0}
  }

  componentDidMount() {
    this._Fetch();
  }

  _Fetch() {
    Request.getFetch(REO + "1" + CONTACT_CENTER + this.state.date).then((json) => {
      this.setState({data: json.data, firstWeek: json.firstWeek, loaded: true});
    });
    this.setState({loaded: false});
  }

  callback = (dataFromChild) => {
    this.setState({date: Parse.toCustomDateLastDay(dataFromChild)}, function stateUpdateComplete() {
      this._Fetch();
    }.bind(this));
  };

  render() {

    const tableClass1 = classNames({
      'table': true,
      'table-striped': this.props.striped,
      'table-bordered': this.props.bordered,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed,
    });
    const tableClass2 = classNames({
      'table': true,
      'table-striped': this.props.striped,
      'table-bordered': this.props.bordered,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed,
    });

    var week_headers = [];

    if (this.state.data.length > 0) {
      for (var i = 0; i < this.state.data[0].values.length; i++) {
        if (i === (this.state.data[0].values.length - 1)) {
          week_headers.push(<th colSpan={this.state.data[0].values[0].cathegories.length}
                                className={'align-middle text-center p-1'}> Totales </th>)
        }
        else {
          week_headers.push(<th colSpan={this.state.data[0].values[0].cathegories.length}
                                className={'align-middle text-center p-1'}> Semana {this.state.firstWeek + i}</th>)
        }
      }
    }

    var cathegories_headers = [];

    if (this.state.data.length > 0) {
      this.state.data[0].values.map((value) => {
        value.cathegories.map((cathegory) => {
          cathegories_headers.push(<td className={'text-center'}
                                       style={{backgroundColor: '#FFF', color: '#000'}}>{cathegory.cathegory}</td>);
        })
      });
    }

    var rows = [];
    var rowsbu = [];

    this.state.data.map((bu) => {
      var columns = [];

      bu.values.map((value) => {
        value.cathegories.map((cathegory) => {
          columns.push(<td className={'text-right th-custom2'}>{Formatter.formatNumber(cathegory.amount)}</td>);
        });
      });

      rows.push(<tr>
        {columns}</tr>);

      rowsbu.push(<tr>
        <th>{bu.bu}</th>
      </tr>);


    });

    return (
      <div className={'m-1'} key={this.state.key}>
        <div className="offset-md-9 col-md-3">
          <BoxSingle
            title={<SimpleMonthPicker callbackFromParent={this.callback}/>}
            subtitle="Periodo"
          >
          </BoxSingle>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3 p-0">
              <table className={tableClass1}>
                <thead className={'p-5'} style={{color: '#FFF', backgroundColor: '#78909C'}}>
                <tr>
                  <th rowSpan={5} className={'th-custom align-middle'}
                      style={{color: '#FFF', backgroundColor: '#78909C'}}>Reporte Contact Center
                  </th>
                </tr>
                </thead>
                <tbody>
                {rowsbu}
                </tbody>
              </table>
            </div>
            <div className="col-md-9 p-0 adjustTable">
              <table className={tableClass2}>
                <thead className={'p-2'} style={{color: '#FFF', backgroundColor: '#78909C'}}>
                <tr>{week_headers}</tr>
                <tr>{cathegories_headers}</tr>
                </thead>
                <tbody>
                {rows}
                </tbody>
              </table>
              <Loader loaded={this.state.loaded}/>
            </div>
            {/*{buttons}*/}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/tables/reoContactCenter.js